import { lampImg, moonImg, lampImages, moonImages } from './productImages';
import { resolveProductPricing } from '../utils/formatPrice';

const repeatImage = (src, count = 4) => Array.from({ length: count }, () => src);

const extras = {
  lamp: {
    displayName: 'Wooden Halo Lamp',
    shortDescription: 'Handcrafted solid wood table lamp with a cozy ambient glow.',
    rating: 4.9,
    reviewCount: 47,
    description:
      'Add warmth and character to your space with this handcrafted solid wood table lamp. ' +
      'Featuring a modern open-frame design and a natural wood finish, it creates a cozy ambient glow, ' +
      'making it perfect for bedside tables, desks, consoles, and living spaces. The front and side surfaces ' +
      'are carefully polished to enhance and showcase the natural wood grain, while the back surface is finished ' +
      'with a smooth protective clear coat for a clean, refined appearance.',
    size: [
      'Height: 13 inches',
      'Width: 8 inches',
      'Thickness: 3 inches',
      'Includes 4W LED Edison-style bulb',
    ],
    careInstructions: [
      'Avoid moisture and harsh cleaning products.',
      'Do not pull, lift, or carry the lamp by the wire or bulb holder. Always hold the wooden body while moving it.',
    ],
    delivery: 'Estimated delivery: 5–7 business days.',
    disclaimer:
      'Actual product color may vary slightly due to lighting and screen settings. As each lamp is handcrafted from natural wood, slight variations in grain, texture, and finish make every piece unique. The front and side surfaces are carefully polished to enhance and showcase the natural wood grain, while the back surface is finished with a smooth protective clear coat for a clean, refined appearance.',
    images: lampImages,
    reviews: [
      {
        id: 1,
        name: 'Sarah Ahmed',
        rating: 5,
        date: '2025-11-12',
        comment: 'Absolutely stunning craftsmanship. The warm glow transforms our living room every evening.',
      },
      {
        id: 2,
        name: 'Omar Hassan',
        rating: 5,
        date: '2025-10-28',
        comment: 'Premium quality wood and the attention to detail is remarkable. Worth every rupee.',
      },
    ],
  },
  moon: {
    displayName: 'Moon Wall Hanging',
    shortDescription:
      'Handcrafted moon wall art with a detailed lunar surface and soft warm-white LED glow.',
    rating: 4.8,
    reviewCount: 32,
    description:
      'Bring the beauty of the night sky into your home with this handcrafted Moon Wall Hanging, designed to replicate the intricate craters and textures of the lunar surface. Encased in a sleek black frame with a soft warm-white LED halo, it creates a calming ambient glow that transforms any bedroom, living room, hallway, office, or reading corner into a serene space. The highly detailed moon surface adds depth and realism, making it both a functional light and a striking piece of wall art.',
    size: ['Diameter: 18 inches', 'Thickness: 1.25 inches'],
    features: [
      'Realistic 3D moon surface with detailed crater texture.',
      'Soft warm LED backlighting for a relaxing ambient glow.',
      'Ideal for bedrooms, living rooms, lounges, offices, cafés, and creative spaces.',
    ],
    careInstructions: [
      'Avoid direct contact with the textured surface.',
      'Avoid moisture and direct water contact.',
      'Do not place excessive weight or pressure on the textured moon surface.',
    ],
    delivery: 'Estimated delivery: 5–7 business days.',
    disclaimer:
      'Actual product color may vary slightly due to lighting conditions and screen settings. As each Moon Wall Lamp is individually handcrafted and finished, slight variations in texture, detailing, and finish may occur, making every piece uniquely beautiful.',
    images: moonImages,
    reviews: [
      {
        id: 1,
        name: 'Fatima Khan',
        rating: 5,
        date: '2025-12-01',
        comment: 'The moon design is perfect for our minimalist home. Beautiful and functional.',
      },
      {
        id: 2,
        name: 'Ali Raza',
        rating: 4,
        date: '2025-11-05',
        comment: 'Elegant lamp with excellent build quality. Delivery was fast too.',
      },
    ],
  },
};

export const enrichProduct = (apiProduct) => {
  const slugKey = (apiProduct.slug || apiProduct.id || '').toLowerCase();
  const extra = extras[slugKey] || {};
  const defaultImage = slugKey === 'moon' ? moonImg : lampImg;
  const fallbackImage = extra.images?.[0] || defaultImage;
  const images =
    extra.images?.length > 0
      ? extra.images
      : fallbackImage
        ? repeatImage(fallbackImage)
        : [];
  const pricing = resolveProductPricing(apiProduct);
  const description = extra.description || apiProduct.shortDescription || '';

  return {
    id: apiProduct.id,
    title: extra.displayName || apiProduct.name,
    slug: apiProduct.slug,
    ...pricing,
    stock: Number(apiProduct.stock) || 0,
    shortDescription:
      extra.shortDescription ||
      description.slice(0, 120) + (description.length > 120 ? '…' : ''),
    description,
    size: extra.size || [],
    features: extra.features || [],
    careInstructions: extra.careInstructions || [],
    delivery: extra.delivery || '',
    disclaimer: extra.disclaimer || '',
    category: apiProduct.category || 'General',
    rating: extra.rating || 4.5,
    reviewCount: extra.reviewCount || 0,
    images: images.length > 0 ? images : [fallbackImage],
    imageUrl: images[0] || fallbackImage,
    reviews: extra.reviews || [],
  };
};

export const categories = ['All', 'Ambient', 'Scandinavian', 'Table', 'Floor'];
